import React from 'react';

const ScenarioPreview: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-950 to-navy-900 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-light text-white mb-8">Scenario Preview</h1>
        <p className="text-slate-300">Scenario preview interface will be implemented here.</p>
      </div>
    </div>
  );
};

export default ScenarioPreview;